export default {"src":"/_next/static/media/ic-mobile-menu.0f75a2d3.svg","height":24,"width":24};